import { INT_EXT, SHOOT_TIMES, UNITS } from './enums';

export function displayIntExt(intExt: INT_EXT) {
	return INT_EXT[intExt].replace('_', '/');
}

export function displayShootTime(shootTime: SHOOT_TIMES) {
	return SHOOT_TIMES[shootTime];
}

export function displayUnit(unit: UNITS) {
	const u = UNITS[unit];
	return u;
}
